import styled from 'styled-components';
import { TDROPDOWN_PROPS, TNAV_LINK_STRUCTURE } from '../types';
import { DropdownHeading } from './DropdownHeading';
import { NavLink } from './NavLink';

const dropdownWidth = {
  outerwidth: [16, 42, 65],
  innerwidth: ['w-full', 'w-1/2', 'w-1/3'],
};

export const GeneralColDropdown = ({
  activeState,
  dropdownList,
  topMenu,
}: TDROPDOWN_PROPS): JSX.Element => {
  if (!dropdownList) return <div></div>;
  const width = `${dropdownWidth.outerwidth[dropdownList.length - 1]}vw`;
  const left = dropdownList.length > 2 ? '17%' : '';

  const DropdownStyle = styled.div`
    width: ${width};
    left: ${left};

    @media (min-width: 768px) and (max-width: 1023px) {
      width: auto;
    }
  `;

  return (
    <DropdownStyle
      className={` ${activeState ? '' : 'hidden'} ${
        topMenu ? ' sm:absolute ' : ''
      } origin-top-right rounded-md shadow-md sm:shadow-none absolute z-50 pt-2 focus:outline-none overflow-hidden sm:overflow-y-scroll md:max-h-[80vh] md:overflow-y-scroll`}
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabIndex={-1}
    >
      <div className="bg-white">
        <div className="flex">
          {dropdownList.map((ele: TNAV_LINK_STRUCTURE) => {
            const columns =
              dropdownList.length === 1
                ? 'w-full py-2'
                : `w-1/${dropdownList.length} py-8`;
            return (
              <div
                className={`${columns} ${
                  ele?.bgColor ? 'bg-clearsky-60' : 'bg-white'
                } 
                ${ele.orderpc ? `order-${ele.orderpc} ` : 0}  
                `}
                key={ele.name}
              >
                <DropdownHeading name={ele.name} />

                {ele.child.map((item) => {
                  return (
                    <NavLink key={item.title} childEle={item} parentEle={ele} />
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </DropdownStyle>
  );
};
